import { WDHFlexspotPardotForm } from "./../../../../wdh-feature/wdh-flexspot-pardot-form";
import { ComponentBootstrap } from "@demant/react-bootstrap";
import flexSpotSchema from "@demant/react-bootstrap/lib/schemas/flex-spot";
DGS.OnLoad.getInstance().register(function () {
  var myComponent = new ComponentBootstrap(".flex-spot.pardot-form");
  myComponent.schemaData = flexSpotSchema;
  myComponent.reactApp = WDHFlexspotPardotForm;
  myComponent.run();
});